import { render, staticRenderFns } from "./deductionDetail.vue?vue&type=template&id=b6bdf4f2&"
import script from "./deductionDetail.vue?vue&type=script&lang=js&"
export * from "./deductionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports